import React from 'react'
import TaskList from './TaskList'

const index = () => {
    return (
        <TaskList />
    )
}

export default index